import { render, staticRenderFns } from "./personCard.vue?vue&type=template&id=5d057f68&scoped=true&"
import script from "./personCard.vue?vue&type=script&lang=js&"
export * from "./personCard.vue?vue&type=script&lang=js&"
import style0 from "./personCard.vue?vue&type=style&index=0&id=5d057f68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d057f68",
  null
  
)

export default component.exports